import React, { useEffect, useState } from 'react';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

const Input = ({
  type = 'text',
  placeholder = '',
  label = 'label',
  register,
  errorMessage,
  name,
  required = false,
  setVal = () => {},
  onChange = () => {},
}) => {
  const [htmlName, setHtmlName] = useState('name');

  useEffect(() => {
    if (name) {
      setHtmlName(name);
    } else {
      setHtmlName(label.toLowerCase().split(' ').join('_'));
    }
  }, [label, name]);

  switch (type) {
    case 'submit':
      return (
        <input
          type="submit"
          value={label}
          className="px-8 py-3 cursor-pointer mt-8 bg-suzGreen text-black border border-suzGreen bg-transparent transition-all duration-150"
        />
      );
    case 'number':
      return (
        <div>
          <label>
            {label}
            {required ? (
              <span className="text-red-500 text-md relative -top-1 left-1">
                *
              </span>
            ) : null}
          </label>
          <input
            type="number"
            className="mt-2 h-12 flex-1 appearance-none border border-gray-300 w-full py-6 px-2 bg-black text-white placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:ring-suzGreen focus:border-transparent"
            placeholder={placeholder}
            {...register(htmlName)}
            onChange={onChange}
          />
          <ErrorMessage message={errorMessage} />
        </div>
      );
    case 'text':
      return (
        <div className="mb-8">
          <label className="uppercase tracking-widest text-xl">
            {label}
            {required ? (
              <span className="text-red-500 text-md relative -top-1 left-1">
                *
              </span>
            ) : null}
          </label>
          <input
            type="text"
            className="mt-2 h-12 flex-1 appearance-none border border-gray-300 w-full py-6 px-2 bg-black text-white placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:ring-suzGreen focus:border-transparent"
            placeholder={placeholder}
            {...register(htmlName)}
            onChange={onChange}
          />
          <ErrorMessage message={errorMessage} />
        </div>
      );
    case 'email':
      return (
        <div className="mb-8">
          <label className="uppercase tracking-widest text-xl">
            {label}
            {required ? (
              <span className="text-red-500 text-md relative -top-1 left-1">
                *
              </span>
            ) : null}
          </label>
          <input
            type="email"
            className="mt-2 h-12 flex-1 appearance-none border border-gray-300 w-full py-6 px-2 bg-black text-white placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:ring-suzGreen focus:border-transparent"
            placeholder={placeholder}
            {...register(htmlName)}
            onChange={onChange}
          />
          <ErrorMessage message={errorMessage} />
        </div>
      );
    case 'date':
      return (
        <div className="mb-8">
          <label className="uppercase tracking-widest text-xl">
            {label}
            {required ? (
              <span className="text-red-500 text-md relative -top-1 left-1">
                *
              </span>
            ) : null}
          </label>
          <input
            type="date"
            className="mt-2 h-12 flex-1 appearance-none border border-gray-300 w-full py-6 px-2 bg-black text-white placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:ring-suzGreen focus:border-transparent"
            {...register(htmlName)}
            onChange={onChange}
          />
          <ErrorMessage message={errorMessage} />
        </div>
      );

    default:
      return <h1>default</h1>;
  }

  // return (
  //   <div className="relative mb-4">
  //     {type === 'submit' ? (
  //       <input
  //         type="submit"
  //         value={label}
  //         className="px-8 py-3 cursor-pointer rounded-full mt-8 border-suzGreen border-2 text-suzGreen bg-transparent hover:bg-suzBlue hover:text-white transition-all duration-150"
  //       />
  //     ) : type === 'text' ? (
  //       <div>
  //         <label>{label}</label>
  //         <input
  //           type="text"
  //           className="mt-2 h-12 flex-1 appearance-none border border-gray-300 w-full py-2 px-2 bg-white text-gray-700 placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:ring-suzGreen focus:border-transparent"
  //           placeholder={placeholder}
  //           {...register(label.toLowerCase().split(' ').join('_'))}
  //         />
  //         <ErrorMessage message={errorMessage} />
  //       </div>
  //     ) : type === 'date' ? (
  //       <div>
  //         <label>{label}</label>
  //         <input
  //           type="date"
  //           className="mt-2 h-12 flex-1 appearance-none border border-gray-300 w-full py-2 px-2 bg-white text-gray-700 placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:ring-suzGreen focus:border-transparent"
  //           {...register(label.toLowerCase().split(' ').join('_'))}
  //         />
  //         <ErrorMessage message={errorMessage} />
  //       </div>
  //     ) : (
  //       <h1>test</h1>
  //     )}
  //   </div>
  // );
};

export default Input;
